export default __webpack_public_path__ + "static/media/spotify.ef25880c.svg";